var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[(_vm.angle && _vm.angle2 < 180 && _vm.showAngle)?_c('text',{attrs:{"x":-64,"y":44}},[_vm._v(" "+_vm._s(_vm.angle1)+"° ")]):_vm._e(),(_vm.angle && _vm.angle2 >= 180 && _vm.showAngle)?_c('text',{attrs:{"x":-64,"y":-44}},[_vm._v(" "+_vm._s(_vm.angle2)+"° ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }